import SSRStorage from '../services/storage';
import {
	TOGGLE_PRELOADING,
	SIGN_OUT,
	TOGGLE_CONNECTED,
	TOGGLE_IS_MODAL,
	TOGGLE_MODAL,
	TOGGLE_VIEW_PAYROLL_HISTORY,
	TOGGLE_VIEW_CURRENT_PAYROLL,
	TOGGLE_EDIT_PAYROLL,
	CREAE_NEW_DRUG,
	CREATE_NEW_GENERIC,
	REFRESH_PRESCRIPTIONS,
	TOGGLE_CHAT_INBOX,
	NEW_CHAT_MESSAGE,
	RESET_CHAT_MESSAGE,
	TOGGLE_SESSION_TIMEOUT,
	TOGGLE_MEDIA_CONNECTED,
} from '../actions/types';
import { SESSION_TIMEOUT } from '../services/constants';

const storage = new SSRStorage();

const INITIAL_STATE = {
	preloading: true,
	is_modal_open: false,
	is_modal: false,
	socket_connected: false,
	media_socket_connected: false,
	view_payroll_history: false,
	current_payroll: false,
	edit_payroll: false,
	payroll_id: null,
	payroll_staff: null,
	staff: null,
	create_new_drug: false,
	create_new_generic: false,
	refresh_prescriptions: false,
	inbox_visible: false,
	message_count: 0,
	session_timeout: localStorage.getItem(SESSION_TIMEOUT) || false,
};

const general = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case TOGGLE_PRELOADING:
			return { ...state, preloading: action.payload };
		case TOGGLE_CONNECTED:
			return { ...state, socket_connected: action.payload };
		case TOGGLE_MEDIA_CONNECTED:
			return { ...state, media_socket_connected: action.payload };
		case SIGN_OUT:
			return { ...state, ...INITIAL_STATE, preloading: false };
		case TOGGLE_IS_MODAL:
			return { ...state, is_modal: action.payload };
		case TOGGLE_MODAL:
			return { ...state, is_modal_open: action.payload };
		case TOGGLE_SESSION_TIMEOUT:
			storage.setLocalStorage(SESSION_TIMEOUT, action.payload);
			return { ...state, session_timeout: action.payload };
		case TOGGLE_VIEW_PAYROLL_HISTORY:
			return {
				...state,
				view_payroll_history: action.payload,
				payroll_staff: action.staff,
			};
		case TOGGLE_VIEW_CURRENT_PAYROLL:
			return {
				...state,
				current_payroll: action.payload,
				payroll_id: action.id,
			};
		case TOGGLE_EDIT_PAYROLL:
			return { ...state, edit_payroll: action.payload, payroll_id: action.id };

		case CREAE_NEW_DRUG:
			return { ...state, create_new_drug: action.payload };
		case CREATE_NEW_GENERIC:
			return { ...state, create_new_generic: action.payload };
		case REFRESH_PRESCRIPTIONS:
			return { ...state, refresh_prescriptions: action.payload };
		case TOGGLE_CHAT_INBOX:
			return { ...state, inbox_visible: action.payload };
		case NEW_CHAT_MESSAGE:
			return { ...state, message_count: state.message_count + 1 };
		case RESET_CHAT_MESSAGE:
			return { ...state, message_count: 0 };
		default:
			return state;
	}
};

export default general;
